<template>
  <div class="flex flex-col gap-4 items-start">
    <p
      ref="textRef"
      :class="{ 'line-clamp-3': !isExpanded }"
      class="text-neutral-70 break-words whitespace-pre-wrap"
    >
      {{ text }}
    </p>
    <button
      v-if="isOverflowing || isExpanded"
      class="text-headline-4 text-neutral-60 hover:underline"
      @click="isExpanded = !isExpanded"
    >
      {{ isExpanded ? t('seeLess') : t('seeMore') }}
    </button>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import { useResizeObserver } from '@vueuse/core'

const { t } = useI18n()
const { text } = defineProps({
  text: {
    type: String,
    required: true,
  },
})

const textRef = ref(null)
const isExpanded = ref(false)
const isOverflowing = ref(false)

const checkOverflow = async () => {
  await nextTick()

  const el = textRef.value
  if (!el) return

  if (el.scrollHeight > el.clientHeight) {
    isOverflowing.value = true
  } else {
    isOverflowing.value = false
  }
}

watch(() => text, checkOverflow)
watch(isExpanded, checkOverflow)
useResizeObserver(textRef, checkOverflow)
onMounted(() => checkOverflow())
</script>

<style lang="scss" scoped></style>
